module.exports = __webpack_public_path__ + "img/yellowGenreIcon.38a75b6c.svg";